var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 2.66669H20C20.7072 2.66669 21.3855 2.94764 21.8856 3.44774C22.3857 3.94783 22.6666 4.62611 22.6666 5.33335V8.00002H20V5.33335H7.99998V26.6667H20V24H22.6666V26.6667C22.6666 27.3739 22.3857 28.0522 21.8856 28.5523C21.3855 29.0524 20.7072 29.3334 20 29.3334H7.99998C7.29274 29.3334 6.61446 29.0524 6.11436 28.5523C5.61426 28.0522 5.33331 27.3739 5.33331 26.6667V5.33335C5.33331 4.62611 5.61426 3.94783 6.11436 3.44774C6.61446 2.94764 7.29274 2.66669 7.99998 2.66669Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4533 20.7866L23.3333 22.6666L30 16L23.3333 9.33331L21.4533 11.2133L24.8933 14.6666H12V17.3333H24.8933L21.4533 20.7866Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c75319d365415f24ad0c28364442104c.svg";
export { ForwardRef as ReactComponent };